import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const networkErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      switch (error.status) {
        case 401: {
          snackBar.open('Користувача не авторизовано', 'Замкнути', {
            duration: 3000,
          });
          router.navigate(['/login'], { queryParams: { returnUrl: req.url } });
          break;
        }
        // No redirect here: bouncing a 403 to /login produced a login -> 403 -> login loop for accounts that
        // authenticate fine but lack the role. Re-authenticating only helps a 401.
        case 403: {
          snackBar.open('Доступ заборонено: недостатньо прав', 'Замкнути', {
            duration: 3000,
          });
          break;
        }
        case 404: {
          snackBar.open('Сторінку не знайдено', 'Замкнути', {
            duration: 3000,
          });
          router.navigate(['/login'], { queryParams: { returnUrl: req.url } });
          break;
        }
        case 500:
        case 501:
        case 502:
        case 503:
        default: {
          snackBar.open(`Помилка ${error.status}. ${error.error?.message || error.message}`, 'Замкнути', {
            duration: 3000,
          });
        }
      }

      return throwError(() => error);
    }),
  );
};
